import { http, HttpResponse, delay } from "msw";

const customers = [
    {
        "id": "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
        "name": "Luis Aguilar",
        "email": "luis.aguilar.rocha@gmail.com",
        "phone": "6622050973",
        "rfc": "AURL910425B46"
    },
    {
        "id": "1c61dd07-036e-46a3-84b6-bde290510ce2",
        "name": "Luis Aguilar",
        "email": "luis.aguilar.rocsha@gmail.com",
        "phone": "6622050973",
        "rfc": "AURL910425B46"
    }
];

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}`

export const customersHandlers = [
    http.get(`${baseUrl}/customers`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            customers,
            { status: 200 }
        );
    }),
    http.get(`${baseUrl}/customers/sale`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            customers,
            { status: 200 }
        );
    }),
    http.post(`${baseUrl}/customers`, async ({ request }) => {
        const { name, email, phone, rfc } = await request.json();
        const newCustomer = {
            id: "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            name,
            email,
            phone,
            rfc
        }
        customers.push(newCustomer)

        await delay(800);

        return HttpResponse.json(
            newCustomer,
            { status: 200 }
        );
    }),
    http.put(`${baseUrl}/customers`, async ({ request }) => {
        const { name, email, phone, rfc } = await request.json();
        const newCustomer = {
            id: "bbfb85bb-315d-421d-bb4b-94cbf6953a79",
            name,
            email,
            phone,
            rfc
        }
        customers.push(newCustomer)

        await delay(800);

        return HttpResponse.json(
            newCustomer,
            { status: 200 }
        );
    }),
    http.delete(`${baseUrl}/customers/:id`, async ({ params }) => {
        const { id } = params;

        const index = customers.findIndex(c => c.id === id);

        if (index === -1) {
            return HttpResponse.json(
                { message: 'Customer not found' },
                { status: 404 }
            );
        }

        const deletedCustomer = customers[index];
        customers.splice(index, 1);

        await delay(800);

        return HttpResponse.json(
            deletedCustomer,
            { status: 200 }
        );
    })
];
